/**
 * Copyright © 2026 Adnuntius AS.
 */
import {SignalResourceListBindingService} from '../../common/controller/signal-resource-list-binding.service';
import {DestroyRef, inject, Component, Inject, Input, OnInit} from '@angular/core';
import * as _ from 'lodash';

import template from './order-list-widget.component.html';
import {OrderApiService} from '../../order/order-api.service';
import {
  WorkspaceListColumn,
  isWorkspaceColumnSortable,
  workspaceChangePage,
  workspaceColumnLabel,
  workspacePageNumbers,
  workspacePageRangeEnd,
  workspacePageRangeStart,
  workspaceSortBy,
  workspaceTotalPages
} from './workspace-widget-list-commons';

@Component({
  standalone: false,
  selector: 'adn-order-list-widget',
  template
})
export class OrderListWidgetComponent implements OnInit {
  private readonly listLifetime = inject(DestroyRef);
  @Input() widgetType: any;

  list: any = {};
  get displayItems(): any[] { return this.list?.listState?.items() || []; }
  get hasItems(): boolean { return this.displayItems.length > 0; }
  get listPageSize(): number { return this.list?.listState?.pageSize || 25; }
  get listTotalCount(): number { return this.list?.listState?.totalCount() || 0; }
  get listCurrentPage(): number { return this.list?.listState?.currentPage() || 1; }
  get displayPage(): any { return {pageSize: this.listPageSize, totalCount: this.listTotalCount, currentPage: this.listCurrentPage}; }
  readonly columnHeaderFields: WorkspaceListColumn[] = [
    {param: '', label: 'blank'},
    {param: 'name', label: 'order'},
    {param: '', label: 'advertiser'}
  ];

  readonly isColumnSortable = isWorkspaceColumnSortable;
  readonly columnLabel = workspaceColumnLabel;
  readonly sortBy = workspaceSortBy;
  readonly changePage = workspaceChangePage;
  readonly totalPages = workspaceTotalPages;
  readonly pageNumbers = workspacePageNumbers;
  readonly pageRangeStart = workspacePageRangeStart;
  readonly pageRangeEnd = workspacePageRangeEnd;

  constructor(
    private readonly orderApi: OrderApiService,
    private readonly listBinding: SignalResourceListBindingService
  ) {
  }

  ngOnInit(): void {
    this.list = this.listBinding.create(this.orderApi, 'orderWidgetList', this.listLifetime, {
      loadPage: (params) => this.orderApi.getListView(params),
      pageSize: Math.min((_.isFinite(this.widgetType.rows) && this.widgetType.rows > 0 ? this.widgetType.rows : 10), 100),
      afterFill: () => {
        _.forEach(this.list.items, (item: any) => {
          item.lineItems = _.map(item.lineItems);
        });
      }
    });
  }

  toggleLineItems(item: any): void {
    item.expandLineItems = !item.expandLineItems;
  }
}
